import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

const SIGNED_URL_EXPIRY = '100y';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

interface CdnSignedUrlResponse {
  signedUrl: string;
  expiresAt: string;
  expiresIn: number;
  expiresInFormat: string;
}

interface CdnBatchSignedUrlResponse {
  signedUrls: string[];
  expiresAt: string;
  expiresIn: number;
  expiresInFormat: string;
}

@Injectable({
  providedIn: 'root',
})
export class CdnResourcesSignerService {
  constructor(private http: HttpClient) {}

  async getSignedUrl(path: string): Promise<string> {
    const response = await firstValueFrom(
      this.http.post<CdnSignedUrlResponse>(
        environment.cdnResourcesSignerServer,
        {
          path,
          expiresIn: SIGNED_URL_EXPIRY,
        },
        httpOptions,
      ),
    );
    return response.signedUrl;
  }

  async getSignedUrls(paths: string[]): Promise<string[]> {
    const response = await firstValueFrom(
      this.http.post<CdnBatchSignedUrlResponse>(
        environment.cdnResourcesSignerServer,
        {
          paths,
          expiresIn: SIGNED_URL_EXPIRY,
        },
        httpOptions,
      ),
    );
    return response.signedUrls;
  }
}
